import type { FlowSubscription } from '@adv-frontend/modules-flow';

/**
 * Создает коллекцию слушателей с управлением жизненным циклом.
 *
 * @param options - Опции коллекции
 * @returns Объект для управления коллекцией слушателей
 */
export function createListenersCollection({ onAdd, onActivate }: ListenersCollectionOptions) {
    let listenerCount = 0;
    let deactivate: (() => void) | null = null;

    return {
        add(listener: () => void): FlowSubscription {
            if (listenerCount === 0) {
                deactivate = onActivate();
            }

            let active = true;
            listenerCount++;

            const subscription = onAdd(listener);

            return {
                unsubscribe() {
                    if (!active) {
                        return;
                    }

                    active = false;
                    listenerCount--;

                    subscription.unsubscribe();

                    if (listenerCount === 0) {
                        deactivate?.();
                        deactivate = null;
                    }
                },
            };
        },
        hasListeners() {
            return listenerCount > 0;
        },
        reset() {
            deactivate?.();
            deactivate = null;
            listenerCount = 0;
        },
    };
}

/**
 * Опции для создания коллекции слушателей.
 */
export interface ListenersCollectionOptions {
    /**
     * Callback при добавлении слушателя
     * @param listener - Callback слушателя
     * @returns Объект для управления подпиской
     */
    onAdd(listener: () => void): FlowSubscription;
    /**
     * Callback при добавлении первого слушателя
     * @returns Callback при удалении последнего слушателя
     */
    onActivate(): () => void;
}
